module.exports = __webpack_public_path__ + "static/media/pedestrian.ea85b763.svg";